import React, { useContext, useEffect, useState } from "react";
import DistribucionList from "../../components/DistribucionList/DistribucionList";
import distribucionesContext from "../../context/distribuciones/distribucionesContext";
import authContext from '../../context/authentication/authContex';
import Swal from 'sweetalert2';

function Distribucion() {

    const [loading, setLoading] = useState(true);
    const [distribucionesConSubcuentas, setDistribucionesConSubcuentas] = useState([]);

    const aContext = useContext(authContext);
    const { usuario } = aContext;

    const dContext = useContext(distribucionesContext);
    const { distribuciones, subcuentasDistribucion, actualizarDistribuciones, actualizarSubcuentasDistribucion, actualizarDistribucionesDB } = dContext;

    useEffect(() => {
        const fn = async () => {
            await actualizarDistribuciones();
            await actualizarSubcuentasDistribucion();
            setLoading(false);
        };
        fn();
    }, []);

    useEffect(() => {
        buildDistribucionesConSubcuentas();
    }, [loading, distribuciones, subcuentasDistribucion]);

    const buildDistribucionesConSubcuentas = () => {
        let newArray = distribuciones.slice();
        newArray.map((d) => {
            d.subcuentas = subcuentasDistribucion.filter(
                (s) => s.codDim?.replace(/\s+/g, "") === d.codDim?.replace(/\s+/g, "") && s.codDis?.replace(/\s+/g, "") === d.codDis?.replace(/\s+/g, "")
            );
        });
        setDistribucionesConSubcuentas(newArray);
    };

    const handlerActualizarDistribuciones = async () => {
        Swal.fire({
            title: '¿Desea actualizar la lista de distribuciones?',
            text: "Se traerán los datos de Softland para sobreescribir la base de datos de la aplicación.",
            showCancelButton: true,
            confirmButtonText: 'Actualizar',
            cancelButtonText: 'No, cancelar',
            showLoaderOnConfirm: true,
            preConfirm: async () => {
                return await actualizarDistribucionesDB()
                    .then(response => {
                        if (!response.status) {
                            throw new Error(response.msg);
                        }
                        return response;
                    })
                    .catch(error => {
                        Swal.showValidationMessage(`Request failed: ${error}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading()
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await actualizarDistribuciones();
                    await actualizarSubcuentasDistribucion();
                    Swal.fire('Actualizado!', 'La base de datos ha sido actualizada correctamente.', 'success');
                } catch (err) {
                    Swal.fire('Error', 'Ocurrió un error al actualizar los datos.', 'error');
                }
            }
        });
    };

    return (
        <div className="container-list">
            <div className="actualiza-warehouses-container">
                <button className="actualizar-warehouses-btn" onClick={handlerActualizarDistribuciones}>Actualizar Distribuciones</button>
            </div>
            <DistribucionList distribucionesConSubcuentas={distribucionesConSubcuentas} />
        </div>
    );
}

export default Distribucion;
